import { $getRoot } from 'lexical';
import type { EditorState } from 'lexical';
import { $isLinkPreviewNode, LinkPreviewNode } from '../../nodes/LinkPreviewNode';

export type Block =
  | { kind: 'text'; text: string }
  | { kind: 'link'; url: string; title?: string; canonical?: string; hostname?: string; image?: string };

export type Draft = { id: string; body: Block[] };

export function exportEditorStateToDraft(editorState: EditorState, id: string): Draft {
  const body: Block[] = [];

  editorState.read(() => {
    const root = $getRoot();
    const children = root.getChildren();
    for (const child of children) {
      // Accumulate text for this block, excluding link nodes
      let textForParagraph = '';
      const grandChildren: any[] = (child as any).getChildren?.() || [];
      for (const grand of grandChildren) {
        if ($isLinkPreviewNode(grand)) {
          const node = grand as LinkPreviewNode;
          const meta = (node as any).__meta || {};
          body.push({
            kind: 'link',
            url: meta.finalUrl || (node as any).__url,
            title: meta?.title ?? undefined,
            canonical: meta?.finalUrl ?? undefined,
            hostname: meta?.hostname,
            image: meta?.image ?? undefined,
          });
        } else if (grand.getTextContent) {
          textForParagraph += grand.getTextContent();
        }
      }
      if (textForParagraph.length > 0) {
        body.push({ kind: 'text', text: textForParagraph });
      }
    }
  });

  return { id, body };
}


